import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util/i18n-util';
import { Box, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
const t = (key, options?) => translate('teachingOrder', key, options);

const ConfirmEditModal = ({ userName, name }) => {
  const classes = useStyles();
  return (
    <Box>
      <Typography variant="subtitle1">
        {t('youHaveChanged')} {name}. {t('customOrderDescription1')}
      </Typography>
      <Typography variant="subtitle1" className={classes.secondParagraph}>
        {t('customOrderDescription2')}{' '}
        <span className={classes.bold}>
          {t('customOrderDescription3', {
            userName,
          })}
        </span>
        . {t('customOrderDescription4')}.
      </Typography>
    </Box>
  );
};

const useStyles = makeStyles(() => ({
  bold: {
    fontWeight: 'bold',
  },
  secondParagraph: {
    marginTop: '30px',
  },
}));

export default ConfirmEditModal;
